'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _immutable = require('redux-form/immutable');

var _reselect = require('reselect');

var _uiTranslations = require('@wh/ui-translations');

var _loginForm = require('./login-form');

var _loginForm2 = _interopRequireDefault(_loginForm);

var _validate = require('./validate');

var _validate2 = _interopRequireDefault(_validate);

var _actions = require('./actions');

var _actions2 = require('../login-component/actions');

var _selectors = require('../selectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = (0, _reselect.createStructuredSelector)({
    initialValues: _selectors.getFormInitialValues
});


var mapDispatchToProps = {
    submitLoginForm: _actions.submitLoginForm,
    trackingEvent: _actions2.trackingEvent
};

var reduxFormConfig = {
    form: 'loginForm',
    destroyOnUnmount: true,
    validate: _validate2.default
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)((0, _immutable.reduxForm)(reduxFormConfig)((0, _uiTranslations.withTranslator)(_loginForm2.default)));
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-form/Container.js
// module id = 490
// module chunks = 0